<template>
  <div
    class="deal-activity-filter-submenu absolute top-0 right-full z-101 mr-0-5 w-70 rounded-md bg-white p-3 shadow-main"
    data-cy="deal-activity-filter-submenu"
  >
    <slot />
  </div>
</template>

<style scoped>
@reference "@/assets/tailwind.css";

/* Date picker calendar: float to the LEFT of the input (out of the submenu). */
.deal-activity-filter-submenu :deep(.date-filter #litepie > div) {
  @apply left-auto! right-[calc(100%+8px)]! top-0! bottom-auto! transform-none! origin-top-right!;
}

/* Auto-opened checkbox dropdown: pin it below its trigger, match submenu width. */
.deal-activity-filter-submenu :deep(.dropdown-wrapper) {
  @apply absolute! left-0! right-auto! top-[calc(100%+4px)]! w-full! min-w-0! max-w-full!;
}

/* Checkbox option labels: truncate long names; the v-tooltipable directive on
   the inner span (OptionBase / bare option) will show a tooltip on hover. */
.deal-activity-filter-submenu :deep(.dropdown-wrapper li label) {
  @apply min-w-0 max-w-55;
}

.deal-activity-filter-submenu :deep(.dropdown-wrapper li label > *) {
  @apply min-w-0;
}

/* Priority dropdown in the submenu: show label + icon per row. The inbox
   version hides labels to keep the dropdown compact; the submenu has room. */
.deal-activity-filter-submenu :deep(.priority-dropdown #exp_elem_list) {
  @apply block w-full;
}

.deal-activity-filter-submenu :deep(.priority-dropdown #exp_elem_list li) {
  @apply flex items-center justify-start gap-2 px-3 py-1-5;
}

.deal-activity-filter-submenu :deep(.priority-dropdown #exp_elem_list li span:not(.icon)) {
  @apply inline-block text-sm text-headline-new;
}
</style>
